import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  SlotPickerHandler,
  SlotPickerRequest,
  SlotPickerResult,
} from '@libs/util-services';

/**
 * Implementação concreta do SLOT_PICKER_HANDLER pro lessor app.
 *
 * Abre o `<calendar-slot-picker>` (organism da calendar-lib) como modal
 * full-screen. Resolve com o slot escolhido ou `null` se cancelado.
 *
 * Registrado em apps/lessor/.../app-routes.ts como provider do token.
 */
@Injectable({ providedIn: 'root' })
export class LessorSlotPickerHandler implements SlotPickerHandler {
  private readonly modalCtrl = inject(ModalController);

  async pick(request: SlotPickerRequest): Promise<SlotPickerResult | null> {
    // Dynamic import — @libs/calendar é lazy-loaded em /agenda. Importar
    // estaticamente quebra o code-splitting (ESLint @nx/enforce-module-boundaries).
    // eslint-disable-next-line @nx/enforce-module-boundaries
    const { CalendarSlotPickerComponent } = await import('@libs/calendar');

    const modal = await this.modalCtrl.create({
      component: CalendarSlotPickerComponent,
      componentProps: {
        mode: request.mode,
        initialDate: request.initialDate,
        filterByCourtId: request.filterByCourtId,
        filterBySportId: request.filterBySportId,
      },
      // Mesmo padrão do EventCreatorModalComponent: full-screen pra evitar
      // problemas de breakpoint cortando o conteúdo.
      cssClass: 'slot-picker-modal modal-fullscreen',
      backdropDismiss: true,
      showBackdrop: true,
    });

    await modal.present();
    const { data } = await modal.onWillDismiss<SlotPickerResult | null>();

    return data ?? null;
  }
}
